/**  */

// eslint-disable-next-line
import React from 'react';
import { Card, CardContent } from '@material-ui/core';
import { Col } from 'react-grid-system';
import { css, jsx } from '@emotion/core';
import { Link } from 'gatsby';
import { rgba } from 'polished';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import Img from 'react-image';
import moment from 'moment';
import PropTypes from 'prop-types';
import shortid from 'shortid';
// import TextTruncate from 'react-text-truncate';

// Vars
import { themeVars } from '../../config/styles';

// Breakpoints
import { bp } from '../../config/breakpoints';

// Components
import MUIButtonTag from '../Common/Button/MUIButtonTag';
import MUIButtonText from '../Common/Button/MUIButtonText';
import TagItem from '../Common/Tags/TagItem';
import TagsList from '../Common/Tags/TagsList';

const NewsItem = ({ date, image, slug, title, categories, baseSlug, taxSlug }) => {
  const cssWrapper = css`
    margin-bottom: 6rem;
  `;

  const cssItem = css`
    height: 100%;
    width: 100%;
    margin: 0;
    line-height: 1;
    position: relative;

    img {
      width: calc(100% + 5px);
      max-width: 100%;
      line-height: 1;
      margin: 0;

      height: 380px;
      max-height: 380px;
      min-height: 380px;
      object-fit: cover;
    }

    a {
      display: block;
    }
  `;

  const cssTitle = css`
    font-size: 2.4rem;
    text-transform: uppercase;
    color: ${themeVars.root.primary};
    margin-bottom: 20px;
    line-height: 1.2;
  `;

  const cssDate = css`
    text-transform: uppercase;
    font-size: 1.4rem;
    font-weight: 500;
    color: ${themeVars.root.secondary};
    margin: 0 0 0.5rem;
  `;

  const cssButtonWrapper = css`
    position: absolute;
    bottom: 40px;
  `;

  const cssContent = css`
    color: ${rgba('#000', 0.6)};
    margin-bottom: 3rem;
    padding: 40px 40px 70px !important; /* MUI override */
    min-height: 250px;
    max-height: 250px;
    height: 250px;

    @media (max-width: ${bp.mn_lg}) {
      padding: 40px 40px;
    }
  `;

  const cssHeader = css`
    position: relative;
    height: 100%;

    @media (max-width: ${bp.mx_xs}) {
      min-height: 354px;
    }

    &:before {
      position: absolute;
      pointer-events: none;
      bottom: 0;
      background: linear-gradient(0deg, rgba(0, 66, 98, 1) 0%, rgba(0, 66, 98, 0) 50%);
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.1);
      pointer-events: none;
      transition: 250ms ease-in-out all;
    }
  `;

  const cssFooter = css`
    position: absolute;
    bottom: 0;
    padding: 0 1.5rem;
    width: 100%;
    min-height: 96px;
    height: auto;
  `;


  //<Img src={image.sizes.news_item} alt="" /> removed this from line 138 to fix erroring

  return (
    <Col xl={4} lg={4} md={6} sm={12} xs={12} css={cssWrapper}>
      <Card>
        <article css={cssItem}>
          <header css={cssHeader}>
            <Link to={`${slug}/`}>
            </Link>
            <footer css={cssFooter}>
              <TagsList>
                {categories.map((category) => {
                  return (
                    <TagItem
                      baseSlug={baseSlug}
                      taxSlug={taxSlug}
                      slug={category.slug}
                      name={category.name}
                      key={shortid.generate()}
                    >
                      <Link to={`/news/category/${category.slug}/`}>
                        <MUIButtonTag>{category.name}</MUIButtonTag>
                      </Link>
                    </TagItem>
                  );
                })}
              </TagsList>
            </footer>
          </header>

          <CardContent css={cssContent}>
            <p css={cssDate}>{moment(date).format('LL')}</p>
            <h2 css={cssTitle}>{title}</h2>

            <Link css={cssButtonWrapper} to={`${slug}/`}>
              <MUIButtonText variant="text">
                Read more
                <ArrowRightAltIcon color="secondary" />
              </MUIButtonText>
            </Link>
          </CardContent>
        </article>
      </Card>
    </Col>
  );
};

NewsItem.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  date: PropTypes.string.isRequired,
  image: PropTypes.shape({
    sizes: PropTypes.shape({
      news_item: PropTypes.string.isRequired,
    }),
  }).isRequired,
  baseSlug: PropTypes.string.isRequired,
  taxSlug: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default NewsItem;
